import * as React from "react";
const SvgFiRrClawMarks = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-claw-marks_svg__a)">
      <path
        fill="#062147"
        d="M23.887 23.061c.387.593-.366 1.258-.88.772A548 548 0 0 1 .166.998C-.32.483.341-.277.93.116 7.501 4.5 17.001 12.5 23.887 23.061m-.95-10.229c.555.479 1.355-.192.957-.808C19.841 5.753 15.034 2.029 11.96.102c-.618-.388-1.266.408-.789.96C15 5.5 18.5 9 22.937 12.832M.872 9.046c-.566-.336-1.162.402-.715.885a259 259 0 0 0 13.911 13.912c.488.453 1.225-.164.878-.732C10.341 15.576 5 11.5.872 9.046"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-claw-marks_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrClawMarks;
